import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  forwardRef,
  input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DurationInputForm } from './duration-input.form';

@Component({
  selector: 'qaroni-duration-input',
  templateUrl: './duration-input.component.html',
  styleUrls: ['./duration-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DurationInputComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class DurationInputComponent
  extends DurationInputForm
  implements OnInit, ControlValueAccessor
{
  readonly label = input('Duración');
  readonly durationMinutes = input<boolean>(false);

  private onChange: (value: number | null) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit(): void {
    this.subs.add(
      this.form.valueChanges.subscribe(() =>
        this.onChange(this.prepareFormToSend())
      )
    );
  }

  writeValue(value: number | null): void {
    this.populate(value);
    const normalized = this.prepareFormToSend();
    if (normalized !== value) {
      this.onChange(normalized);
    }
  }

  registerOnChange(fn: (value: number | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable();
      return;
    }

    this.form.enable();
    this.syncMinutesLock(this.isAtMaxHours(this.hours.value));
  }

  onBlur(): void {
    this.onTouched();
  }
}
